import type { TOC } from '@ember/component/template-only';
import truncate from 'ember-cli-string-helpers/helpers/truncate';
import EmberTooltip from 'ember-tooltips/components/ember-tooltip';
import { lte, or } from 'ember-truth-helpers';

interface TruncateWithTooltipSignature {
  Args: {
    value?: string | null;
    length: number;
    side?: 'top' | 'right' | 'bottom' | 'left';
    popperContainer?: string;
  };
  Element: HTMLDivElement;
}

export default <template>
  <div class="break-words break-all" ...attributes>
    {{#if (lte @value.length @length)}}
      {{@value}}
    {{else}}
      {{truncate @value @length false}}<span class="text-xs">…</span>
      <EmberTooltip
        @side={{or @side "right"}}
        @delay={{300}}
        @popperContainer={{if @popperContainer @popperContainer false}}
      >
        <div class="break-words break-all">{{@value}}</div>
      </EmberTooltip>
    {{/if}}
  </div>
</template> satisfies TOC<TruncateWithTooltipSignature>;
